"use client";

import { ChevronDown, Tag } from "@/components/icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useListingBrowseContext } from "../context/listing-browse-context";
import { LISTING_INTENT_OPTIONS } from "../context/listing-browse-types";

export function IntentFilter() {
  const { intentFilter, selectIntentFilter, saleOnly } = useListingBrowseContext();
  if (saleOnly) return null;
  const activeLabel = LISTING_INTENT_OPTIONS.find(
    (option) => option.value === intentFilter,
  )?.label;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="compact"
          className={cn(
            "rounded-sm",
            intentFilter !== "all" && "bg-muted text-foreground",
          )}
        >
          <Tag className="text-muted-foreground" />
          <span className="text-foreground">{activeLabel}</span>
          <ChevronDown className="text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[180px] rounded-sm border-border p-1">
        {LISTING_INTENT_OPTIONS.map((option) => (
          <Button
            key={option.value}
            type="button"
            variant="ghost"
            size="compact"
            aria-pressed={intentFilter === option.value}
            onClick={() => selectIntentFilter(option.value)}
            className={cn(
              "w-full justify-start rounded-sm text-left text-sm",
              intentFilter === option.value && "bg-action-tint text-action",
            )}
          >
            {option.label}
          </Button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
